import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/UI/Button';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  button: {},
});

const BackToPreferencesButton = ({
  className,
  classes,
  onClick,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Button
        color="primary"
        className={classes.button}
        onClick={onClick}
      >
        <ArrowBackIosIcon />
        {'Back to Preferences'}
      </Button>
    </div>
  );
};

BackToPreferencesButton.defaultProps = {
  className: '',
  onClick: () => {},
};

BackToPreferencesButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default withStyles(styles)(BackToPreferencesButton);
